import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import {
  AnalyzeWithAiActionIcon,
  ExploreElementsActionIcon,
  FilterElementsActionIcon,
} from './icons/HowElementsExplorerIcons';

type ActionCard = {
  icon: ReactNode;
  title: string;
  subtitle: string;
};

const actionCards: ActionCard[] = [
  {
    title: 'Filter Elements',
    subtitle: 'Narrow down your data',
    icon: <FilterElementsActionIcon />,
  },
  {
    title: 'Explore Elements',
    subtitle: 'Review performance data',
    icon: <ExploreElementsActionIcon />,
  },
  {
    title: 'Analyze with AI',
    subtitle: 'Get actionable insights',
    icon: <AnalyzeWithAiActionIcon />,
  },
];

export function ActionsYouCanTakeSection(): ReactNode {
  return (
    <Box
      sx={{
        alignItems: 'stretch',
        display: 'grid',
        gap: 2,
        gridTemplateColumns: {
          lg: 'repeat(3, minmax(0, 400px))',
          md: 'repeat(2, minmax(0, 1fr))',
          xs: '1fr',
        },
        justifyContent: 'center',
        mt: 2,
      }}
    >
      {actionCards.map((card) => (
        <Box
          key={card.title}
          sx={{
            alignItems: 'center',
            background: '#eff6ff80',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2.5,
            display: 'flex',
            gap: 2,
            p: 3,
          }}
        >
          {card.icon}
          <Box
            sx={{
              minWidth: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <Typography
              sx={{
                color: 'text.primary',
                fontSize: '14px',
                fontWeight: 600,
              }}
            >
              {card.title}
            </Typography>
            <Typography
              sx={{
                color: 'text.secondary',
                fontWeight: 400,
              }}
            >
              {card.subtitle}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
